/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { fuelModalActionProps } from '../../components/ManualUpload/AddFuelModal/ManualInputTab/ManualInputConfiguration';
import { IAnyObject } from '../../components/shared/PerformanceGraph/IPerformanceGraph';

class FileUploadActions {
  static SHOW_MODAL = 'SHOW_MODAL';
  static SHOW_ZLO_MODAL = 'SHOW_ZLO_MODAL';
  static SET_ZLO_FILE = 'SET_ZLO_FILE';
  static SET_ACCEPTED_FILES = 'SET_ACCEPTED_FILES';
  static SET_ACCEPTED_CSV_HEADERS = 'SET_ACCEPTED_CSV_HEADERS';
  static SHOW_ADD_FUEL_MODAL = 'SHOW_ADD_FUEL_MODAL';
  static SET_EDIT_FUEL_MODAL = 'SET_EDIT_FUEL_MODAL';
  static SET_MISSING_FUEL_MODAL = 'SET_MISSING_FUEL_MODAL';
  static HIDE_ADD_FUEL_MODAL = 'HIDE_ADD_FUEL_MODAL';
  static DISABLE_EDIT = 'DISABLE_EDIT';
  static SAVE_API_PAYLOAD = 'SAVE_API_PAYLOAD';
  static SHOW_PUBLISH_MODAL = 'PUBLISH_MODAL';

  static showUploadModal = () => {
    return {
      type: FileUploadActions.SHOW_MODAL,
      payload: true
    };
  };

  static showPublishModal = () => {
    return {
      type: FileUploadActions.SHOW_PUBLISH_MODAL,
      payload: true
    };
  };

  static hideUploadModal = (keepState: boolean = false) => {
    if (keepState) {
      return {
        type: FileUploadActions.SHOW_MODAL,
        payload: { keepState, showModal: false }
      };
    }
    return {
      type: FileUploadActions.SHOW_MODAL,
      payload: false
    };
  };

  static hidePublishModal = (keepState: boolean = false) => {
    if (keepState) {
      return {
        type: FileUploadActions.SHOW_PUBLISH_MODAL,
        payload: { keepState, showPublishModal: false }
      };
    }
    return {
      type: FileUploadActions.SHOW_PUBLISH_MODAL,
      payload: false
    };
  };

  static setAcceptedFile = (files: File[]) => {
    return {
      type: FileUploadActions.SET_ACCEPTED_FILES,
      payload: files
    };
  };

  static setAcceptedCsvHeaders = (headers: string[]) => {
    return {
      type: FileUploadActions.SET_ACCEPTED_CSV_HEADERS,
      payload: headers
    };
  };

  static showAddFuelModal = (configVal: fuelModalActionProps) => {
    return {
      type: FileUploadActions.SHOW_ADD_FUEL_MODAL,
      payload: configVal
    };
  };

  static hideAddFuelModal = () => {
    return {
      type: FileUploadActions.HIDE_ADD_FUEL_MODAL,
      payload: false
    };
  };

  static setMissingFuelModal = (payload: IAnyObject) => {
    return {
      type: FileUploadActions.SET_MISSING_FUEL_MODAL,
      payload: payload
    };
  };

  static setEditFuelModal = (payload: IAnyObject) => {
    return {
      type: FileUploadActions.SET_EDIT_FUEL_MODAL,
      payload: payload
    };
  };

  static disableEdit = () => {
    return {
      type: FileUploadActions.DISABLE_EDIT
    };
  };

  static saveUpdatedPayload = (payload: IAnyObject) => {
    return {
      type: FileUploadActions.SAVE_API_PAYLOAD,
      payload: payload
    };
  };

  static showZLOUploadModal = () => {
    return {
      type: FileUploadActions.SHOW_ZLO_MODAL,
      payload: true
    };
  };

  static hideZLOUploadModal = () => {
    return {
      type: FileUploadActions.SHOW_ZLO_MODAL,
      payload: false
    };
  };

  static setZLOFile = (file: File | null) => {
    return {
      type: FileUploadActions.SET_ZLO_FILE,
      payload: file
    };
  };
}

export default FileUploadActions;
